import React, { useEffect, useState } from 'react';
import './CSS/NotFound.css';

const NotFound = () => {
    const [floatingElements, setFloatingElements] = useState([]);

    useEffect(() => {
        const elements = Array.from({ length: 20 }, (_, i) => ({
            id: i,
            left: Math.random() * 100,
            delay: Math.random() * 2,
            duration: 3 + Math.random() * 2,
            size: 10 + Math.random() * 30
        }));
        setFloatingElements(elements);
    }, []);

    return (
        <div className="not-found-page">
            <div className="animated-bg">
                {floatingElements.map(elem => (
                    <div
                        key={elem.id}
                        className="floating-shape"
                        style={{
                            left: `${elem.left}%`,
                            '--delay': `${elem.delay}s`,
                            '--duration': `${elem.duration}s`,
                            '--size': `${elem.size}px`,
                            '--random-top': `${Math.random() * 100}%`
                        }}
                    />
                ))}
            </div>


            <div className="not-found-container">
                <div className="error-code">404</div>
                <h1>Oops! Page Not Found</h1>
                <p>Sorry, the page you're looking for doesn't exist or has been moved.</p>

                <div className="illustration">
                    <div className="circle-1"></div>
                    <div className="circle-2"></div>
                    <div className="question-mark">?</div>
                </div>

                <div className="button-group">
                    <button className="btn btn-primary" onClick={() => window.location.href = '/'}>
                        Back to Home
                    </button>
                    <button className="btn btn-secondary" onClick={() => window.history.back()}>
                        Go Back
                    </button>
                </div>


            </div>
        </div>
    );
};

export default NotFound;